module.exports = __webpack_public_path__ + "media/images/page/gift-flow02-08211d201514d1fcd8ed2825d2126c3f.jpg";